import {IntermediatePart} from "../../intermediatePart";
import {ShowerTubCombo} from "../../parts/showerTubCombo";
import {SIDE_POSITIONS} from "../../constants";
import {IS_LIXIL_SERVERS} from "../../../../../config";

const hardcodedSkus = ["6438AM-FCOL.218", "6434AM-FCOL.218", "A8007D-FCO.020", "A8007D-FCO.020", "A8004L-CO.020", "4836SM-COL.218"];

export default class ShowerPanCombo extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'shower_pan_combo';
    this.partName = 'Shower Pan';
    this.translateId = "visualizer.bathroom.shower.shower_pan_combo";
    this.visible = true;
    this.isStoneFeature = false;
    this.layerPriority = 8;
    this.canBeDisabled = true;
    if (isChild) {
      this.oneLayerPosition = true;
    }
  }

  load(dbFeature) {
    // dbFeature.metaData["layerPosition"] = dbFeature.metaData["Side"] ? dbFeature.metaData["Side"][0] : "";

    // Our Shower Doors only fit openings: 56"-60" (1422-1524mm) The skus below are too wide and would not be compatible.
    // If a user selects one of these shower bases please hide/do not display a shower door with it.
    if (IS_LIXIL_SERVERS && Array.isArray(dbFeature.metaData["ShowerPanHeight"]) && hardcodedSkus.some(sku => dbFeature.sharedFeatureName  === sku)) {
      dbFeature.metaData["ShowerPanHeight"] = ["99"]; // do not show shower door for these sku's
    }
    dbFeature.metaData["CustomShowerPanSide"] = (dbFeature.sharedFeatureName || "").includes("LHO")
      ? "LHO"
      : (dbFeature.sharedFeatureName || "").includes("RHO") ? "RHO" : "";
    dbFeature.metaData["layerPosition"] = dbFeature.metaData["Side"] && dbFeature.metaData["Side"][0] !== "0"
      ? dbFeature.metaData["Side"][0]
      : (dbFeature.metaData["CustomShowerPanSide"] === "RHO") ? "R" : SIDE_POSITIONS[0];
    dbFeature.metaData["CustomNameWithoutShowerPanSide"] = (dbFeature.sharedFeatureName || "")
      .replace(/LHO/g, "").replace(/RHO/g, "");

    return super.load_(dbFeature, new ShowerPanCombo())
  }

  disabledClick() {
    const shower = this.getParent();
    shower.showerFloorIsActive = this.disabled;
    if (shower.showerDoor) {
      if (this.disabled) {
        if (!shower.showerDoor.disabled) {
          shower.showerDoor.disabled = true;
          shower.showerDoor.disabledClick(); // accessories and shower door handle
          shower.showerDoor.wasDisabledByShowerPan = true;
        }
      } else if (shower.showerDoor.wasDisabledByShowerPan) {
        shower.showerDoor.disabled = false;
        shower.showerDoor.disabledClick(); // accessories and shower door handle
      }
    }
  }

  applyFeatureIfNotCompatible() {
    const parent = this.getParent();
    const shower = parent.getParent();
    shower.showerFloorIsActive = false;
    if (shower.layout && shower.showerTubComboIsActive() && !parent.canRenderWithReplacementTub()) {
      const comboPart = shower.layout.parts[ShowerTubCombo.id];
      comboPart.showerTubComboIsActive = false;
    }
  }

  canRenderWithReplacementTub() {
    const showerParent = this.getParent();
    const comboParent = showerParent.layout?.parts[ShowerTubCombo.id];
    return comboParent?.freeStandingTubActive?.();
  }

  hideLayerCondition() {
    const showerParent = this.getParent();
    if (showerParent.showerFloorIsActive) {
      return true
    }
    if (showerParent.showerTubComboIsActive()) {
      // const comboParent = showerParent.layout?.parts[ShowerTubCombo.id];
      // return comboParent?.bottomTub === "walk_in_tub"
      return !this.canRenderWithReplacementTub()
    }
    return false
  }

  handleClick(ignoreLocked) {
    super.handleClick(ignoreLocked); // set active item & not in visualizer item
    this.applyFeatureIfNotCompatible();
  }

  /**
   * @param navItems {[navItemInterface]}
   * @param forFeature {featureInterface}
   */
  filterNavigationItems(navItems, forFeature = null) {
    let finalNavItems = [];
    const forMeta = forFeature && forFeature.metaData && forFeature.metaData["CustomShowerPanSide"] ? forFeature.metaData["CustomShowerPanSide"] : "LHO";
    const leftNavItems = navItems.filter(navItem => {
      if (!navItem.part.metaData["CustomShowerPanSide"] || (navItem.part.metaData["CustomShowerPanSide"] === forMeta)) {
        finalNavItems.push(navItem);
        return false
      }
      return true
    })
    leftNavItems.forEach(navItem => {
      if (!finalNavItems.some(existingNavItem => {
        if (IS_LIXIL_SERVERS) {
          return existingNavItem.part.metaData["CustomNameWithoutShowerPanSide"] &&
            navItem.part.metaData["CustomNameWithoutShowerPanSide"] === existingNavItem.part.metaData["CustomNameWithoutShowerPanSide"]
        }
        return existingNavItem.part.metaData["MatchingFeature"] && navItem.part.metaData["MatchingFeature"] &&
          navItem.part.metaData["MatchingFeature"][0] === existingNavItem.part.metaData["MatchingFeature"][0]
      })) {
        finalNavItems.push(navItem)
      }
    })
    return finalNavItems
  }

  // /**
  //  * @param neededPosition {string} LHO|RHO
  //  * @param lookActiveFeature {featureInterface}
  //  */
  // getMatchingOutletFeature = (neededPosition = "", lookActiveFeature) => {
  //   if (IS_LIXIL_SERVERS) {
  //     const nameWithoutPos = lookActiveFeature.metaData["CustomNameWithoutShowerPanSide"];
  //     const allNavItems = this.navigationSubItemsSimple();
  //     return allNavItems.find(navItem => {
  //       return (navItem.part.dbFeature.metaData["CustomShowerPanSide"] === neededPosition)
  //         && (navItem.part.metaData["CustomNameWithoutShowerPanSide"] === nameWithoutPos)
  //     })
  //   }
  //   const nameWithoutPos = lookActiveFeature.metaData["MatchingFeature"];
  //   const allNavItems = this.navigationSubItemsSimple();
  //   return allNavItems.find(navItem => {
  //     return (navItem.part.dbFeature.metaData["CustomShowerPanSide"] === neededPosition)
  //       && (navItem.part.metaData["MatchingFeature"][0] === nameWithoutPos)
  //   })
  // }

  // navigationSubItems(filters, searchText) {
  //   return this.navigationSubItemsWithSides(filters, searchText);
  // }

  // getArrayOfConditions() {
  //   let conditions = super.getArrayOfConditions(); //roomLayout
  //   const showerParent = this.getParent();
  //   conditions.push({
  //     propName: "ShowerSize",
  //     propValue: showerParent.showerSize()
  //   });
  //   return conditions
  // }

  canDisplayDemoPoint() {
    const shower = this.getParent();
    return !shower.showerTubComboIsActive()
  }
}
